import React, { useEffect, useState } from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import annotationPlugin from 'chartjs-plugin-annotation';
import { Line } from 'react-chartjs-2';
import staticInformationService from '../../../services/Internal/Staff/dashboardInformation.service';

function DashboardChartLicenseStatus() {
    const [renewalCounts, setRenewalCounts] = useState();
    const [hasLoaded, setHasLoaded] = useState(false);
    const colors = ['#ff595e', '#ff924c', '#ffca3a', '#c5ca30', '#8ac926', '#52a675', '#1982c4', '#4267ac', '#6a4c93', '#d677b8', '#000000']
    ChartJS.register(
        CategoryScale,
        LinearScale,
        PointElement,
        LineElement,
        Title,
        Tooltip,
        Legend,
        annotationPlugin
    );
    const options = {
        interaction: {
            mode: 'index',
            intersect: false,
        },
        stacked: false,
        plugins: {
            legend: {
                position: 'right'
            },
            title: {
                display: true,
                text: 'Renewals by Cycle',
                font: {
                    size: 20,
                    family: 'Arial',
                },
            },
        },
        scales: {
            y: {
                type: 'linear',
                display: true,
                position: 'left',
            },
        },
        maintainAspectRatio: false,
        responsive: true,

    };

    useEffect(() => {
        staticInformationService.getDashboardRenewalCountsByCycle().then((result) => {
            if (result.data) {
                var cycles = [...new Set(result.data.map(obj => obj.cycle))];
                cycles.splice(cycles.indexOf("Unknown"), 1);
                cycles.sort((a, b) => {
                    const firstObjArr = a.split(" ");
                    const secondObjArr = b.split(" ");

                    if (firstObjArr[1] > secondObjArr[1]) {
                        return 1;
                    } else if (firstObjArr[1] < secondObjArr[1]) {
                        return -1;
                    }
                    // Else go to the 2nd item
                    if (firstObjArr[0] > secondObjArr[0]) {
                        return -1;
                    } else if (firstObjArr[0] < secondObjArr[0]) {
                        return 1
                    } else { // nothing to split them
                        return 0;
                    }
                })

                var datasets = Object.values(
                    result.data.reduce((acc, obj) => {
                        const key = JSON.stringify([obj.credentialType, obj.renewingTo]);
                        if (!acc[key]) {
                            acc[key] = [];
                        }
                        acc[key].push(obj);
                        return acc;
                    }, {}));
                var totalDataSet = cycles.map((cycle) => {
                    var total = result.data.filter((dataObj) => dataObj.cycle == cycle).reduce((sum, reduceObj) => sum + reduceObj.count, 0)
                    return {
                        count: total, credentialType: "Totals", cycle: cycle, renewingTo: null
                    }
                });
                datasets.push(totalDataSet);
                setRenewalCounts({
                    labels: cycles,
                    datasets: datasets.map((obj) => {
                        var label = '';
                        switch (obj[0].credentialType) {
                            case "Engineer Intern":
                                label = 'EI';
                                break;
                            case "Engineering Firm":
                                label = "EF";
                                break;
                            case "Land Surveyor Intern":
                                label = "LSI";
                                break;
                            case "Professional Engineer":
                                label = "PE " + obj[0].renewingTo;
                                break;
                            case "Professional Surveyor":
                                label = 'PLS ' + obj[0].renewingTo;
                                break;
                            case "Surveying Firm":
                                label = 'VF';
                                break;
                            case "Totals":
                                label = 'Totals'
                                break;
                            default:
                                label = '';
                        }
                        var data = cycles.map((cycle) => {
                            return obj.find(dataObj => dataObj.cycle === cycle)?.count ?? 0
                        });
                        return { label: label, hidden: obj[0].credentialType != "Totals", data: data, borderColor: colors[datasets.indexOf(obj)], backgroundColor: colors[datasets.indexOf(obj)] }
                    })

                })
            }
            setHasLoaded(true);
        })

    }, [])

    return (
        hasLoaded &&
        <Line data={renewalCounts} options={options} />
    )
}

export default DashboardChartLicenseStatus;